import type { RootState } from "@src/store/rootState";
export const getProductPickerProductCheckboxState =
  (productId: string | undefined, allVariantIds: string[] | undefined) =>
  (state: RootState): { checked: boolean; indeterminate: boolean } => {
    if (!productId) return { checked: false, indeterminate: false };

    const selectedProduct = state.productPicker.selectedProducts.find(
      (p) => p.id === productId
    );

    if (!selectedProduct) return { checked: false, indeterminate: false };
    if (!selectedProduct.selectedVariantIds)
      return { checked: true, indeterminate: false };
    if (selectedProduct.selectedVariantIds.length === 0)
      return { checked: false, indeterminate: false };
    if (
      allVariantIds &&
      selectedProduct.selectedVariantIds.length < allVariantIds.length
    )
      return { checked: false, indeterminate: true };

    return { checked: true, indeterminate: false };
  };
